import WritingCompetitionSuccess from "./WritingCompetitionSuccess";

export default WritingCompetitionSuccess;